import React from "react";
import { Routes, Route } from 'react-router-dom';
import MarketerMenu from "../components/marketerMenu";
import MarketerDetails from "./marketerDetails";
import UserWarehouseRequestList from "./userRequestList";
import CommonEnquiries from "./commonEnquiry";
import ClientEnquiry from "./clientEnquiry";
import WarehouseEnquiryList from "./warehouseEnquiryList";
function MarketerRoute() {
    return (
        <>
            <div className="marketerRoute">
                <div className='container-fluid mt-4'>
                    <div className='row'>
                        {/* Sidebar - 2 columns */}
                        <div className='col-2 p-0'>
                            <MarketerMenu /> {/* Sidebar is always shown on admin routes */}
                        </div>

                        {/* Main content area - 10 columns */}
                        <div className='col-10 user-content pt-5'>
                            <Routes>
                                {/* Default route */}
                                <Route path="/" element={<MarketerDetails />} />

                                {/* Booking list route */}
                                <Route path="/warehouseEnquiryList" element={<WarehouseEnquiryList />} />
                                <Route path="/userBookingList" element={<UserWarehouseRequestList />} />
                                <Route path="/commonEnquiryList" element={<CommonEnquiries />} />
                                <Route path="/clientEnquiryList" element={<ClientEnquiry />} />
                            </Routes>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MarketerRoute